import { render, staticRenderFns } from "./AdjustStockForm.vue?vue&type=template&id=32c24cf1"
import script from "./AdjustStockForm.vue?vue&type=script&lang=js"
export * from "./AdjustStockForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports